import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { reset } from 'redux-form';
// components
import { FormattedMessage } from 'react-intl';
import Preloader from 'components/Preloader';
import Panel from 'components/Panel/index';
import MessageBox from 'components/MessageBox';
import FormErrorsBox from 'components/FormErrorsBox';
import AminoForm from './components/AminoForm';
// utils
import { fetchFromAPI } from 'utils/api';
import { showToastrMessage } from 'utils';
import handleFormErrors from 'utils/handleFormErrors';

const initialState = {
  formValues: {
    username: '',
    password: '',
  },
  isLoading: false,
  passwordHint: '',
};

class AminoIntegration extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.getSettings();
  }

  getSettings = () => {
    const { companyId } = this.props;
    this.setState({ isLoading: true });

    fetchFromAPI(`/admin/companies/${companyId}/amino_credential`)
      .then(({ resource }) => {
        this.setState({
          isLoading: false,
          passwordHint: resource.password_hint,
          formValues: {
            username: resource.username,
            password: '',
          },
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        return handleFormErrors(error);
      });
  };

  handleSubmit = (resource, change) => {
    const { companyId } = this.props;
    const reqParams = { method: 'PUT', body: JSON.stringify({ resource }) };
    this.setState({ isLoading: true });

    return fetchFromAPI(`/admin/companies/${companyId}/amino_credential`, reqParams)
      .then(({ resource }) => {
        showToastrMessage('component.toastr.credentials.updated');
        change('password', '');
        this.setState({
          isLoading: false,
          passwordHint: resource.password_hint,
          formValues: {
            username: resource.username,
          },
        });
      },
      (error) => {
        this.setState({ isLoading: false });
        return handleFormErrors(error);
      });
  };

  resetForm = () => {
    const { companyId, resetForm } = this.props;
    const resource = { username: '', password: '' };
    const reqParams = { method: 'PUT', body: JSON.stringify({ resource }) };
    this.setState({ isLoading: true });

    return fetchFromAPI(`/admin/companies/${companyId}/amino_credential`, reqParams)
      .then(() => {
        resetForm('amino-form');
        showToastrMessage('component.toastr.credentials.cleared');
        this.setState(initialState);
      },
      (error) => {
        this.setState({ isLoading: false });
        return handleFormErrors(error);
      });
  };

  render() {
    const { passwordHint, isLoading, formValues } = this.state;

    return (
      <Panel className="amino-integration">
        <Panel.Heading title="MTech" />
        <Panel.Body className="ph-15">
          <Preloader isActive={isLoading} />

          <div className="row clearfix">
            <section className="small-12 medium-10 large-8 column">

              <MessageBox type="default" className="message-box">
                <FormattedMessage id="component.amino.connectHelperText" />
              </MessageBox>

              <MessageBox type="default" className="message-box">
                <FormattedMessage id="component.amino.disconnectHelperText" />
              </MessageBox>

              <FormErrorsBox formName="amino-form" className="animated fadeIn" />

              <AminoForm
                handleForm={this.handleSubmit}
                resetForm={this.resetForm}
                passwordHint={passwordHint}
                initialValues={formValues}
              />
            </section>
          </div>
        </Panel.Body>
      </Panel>
    );
  }
}

AminoIntegration.propTypes = {
  companyId: T.number.isRequired,
  resetForm: T.func.isRequired,
};

export default connect(
  (state) => ({
    companyId: state.auth.user.current_company.id,
  }), {
    resetForm: reset,
  }
)(AminoIntegration);
